import { FormikProvider, useFormik } from "formik";
import { IVehicleVisualRecord } from "../../../../../types/vehicle-visual-record.type";
import { useEffect, useState } from "react";
import { VehiclesHistoricalRow } from "../fields-upload/VehiclesHistoricalRow";
import { formatDateAndTime } from "../../../../../common/helpers/date.helpers";

type CardDeliveredProps = {
  data: IVehicleVisualRecord;
  onClick?: () => void
  showDeliveredDetails?: boolean;
}

export default function CardDelivered(props: CardDeliveredProps) {

  const [, setvehicleId] = useState<string | null>(null);
  const formik = useFormik({
    initialValues: {
      deliveryPhotos: [
        props.data.photos.deliveryPhotos.find(photo => photo.type === 'Traseira do veículo'),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ] as any,
      // outras propriedades inicializadas aqui
    },
    onSubmit: (values) => { values },
    // outras opções do Formik aqui
  });

  const initialDateAt = props.data.createdAt ? formatDateAndTime(props.data.createdAt.toString()) : '';


  useEffect(() => {
    setvehicleId(props.data.vehicleId);
  }, [props.data]);

  return (
    <FormikProvider value={formik}>
      <div className="flex flex-col z-0 items-center bg-gray2/20 m-1 p-1 pt-4 rounded shadow-md border-b border-gray2 cursor-pointer" onClick={props.onClick}>
        {formik.values?.deliveryPhotos?.map((doc, index) => (
          <div key={index} className={`flex flex-col space-y-2 p-3 my-0 rounded ${index % 2}`}>
            <VehiclesHistoricalRow
              name={`deliveryPhotos.${index}`}
              initialData={doc || {}}
              prefix="devolucao"
              vehicleId={props.data.vehicleId}
            />
          </div>
        ))}

        <p className="text-[.9rem] text-black mx-auto">Entrega</p>
        <p className="text-[.9rem] text-black mx-auto">{initialDateAt}</p>
      </div>
    </FormikProvider>
  )
}



